import styled from "styled-components"

export const FullNameContainer = styled.span`
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  color: #34383c;
`

export const EmailContainer = styled.a`
  color: #1565c0;
`

export const HumanResourceInfoLabel = styled.span`
  font-weight: 700;
  font-size: 14px;
  color: #000 87%;
`

export const HumanResourceValue = styled.span`
  font-size: 14px;
`

export const TabsWrapper = styled.div`
  ul:first-child {
    margin-left: 0;
    margin-bottom: 15px;
  }
`
